import React, { Component } from 'react';
import {
    Row,
    Col,
    Spin,
    Select,
    Form,
    Input,
    Checkbox,
    Button,
    Modal,
    Alert 
} from 'antd';
import UserProvider from '../../js/userProvider';
import DataService from '../../Components/Data';
import CurrencyInput from 'react-currency-input';
import './DadosBancarios.css';

const Option = Select.Option;
const FormItem = Form.Item;
const { TextArea } = Input;

class DadosBancarios extends Component {

    constructor(props) {
        super(props);

        this.state = {
            terceiros: false,
            loading: false,
            bancos: [],
            buscando: true,
            obConta: [],
            amount: "0,00",
            tipoStatus: "success"
        }

        this.dataService = new DataService();
        this.dadosProvider = UserProvider.getInstance();
    }

    componentWillMount() {
        this.getBancos();
        this.getConta();
    }

    getBancos(){

        var filial = this.dadosProvider.getUiFilial();
        var usuario = this.dadosProvider.getDadosUsuario();

        var dados = {
            "uiFilial": filial,
            "cripto": usuario.Cripto
        };

        this.dataService.GetBancoCadastro(dados, (retorno) => {
           
            if (retorno.length > 0) {
                this.setState({ bancos: retorno});
            }

        }, (erro) => {
            console.log(erro);
            //this.setState({ buscando: false });
        });
    }

    getConta(){

        var filial = this.dadosProvider.getUiFilial();
        var usuario = this.dadosProvider.getDadosUsuario();

        var dados = {
            "uiFilial": filial,
            "cripto": usuario.Cripto
        };

        this.dataService.GetContaBancaria(dados, (retorno) => {
            
            //console.log(retorno.CdPessoaContaBancaria);
            this.setState({ buscando: false });
            if (retorno.length > 0) {
                var cor = "error";
                if(retorno[0]["CdStatus"] == "12"){
                    cor = "warning"
                }else if(retorno[0]["CdStatus"] == "11"){
                    cor = "success"
                }
                this.setState({ 
                    obConta: retorno[0], 
                    terceiros: (retorno[0]["StContaTerceiro"] == "1"), 
                    tipoStatus: cor
                });
            }

        }, (erro) => {
            console.log(erro);
            this.setState({ buscando: false });
        });
    }

    terceirosChange = (e) => {
        this.setState({
            terceiros: e.target.checked,
        }, () => {
            //this.props.form.validateFields(['titular', 'tipo_pessoa', 'cnpj'], { force: true });
        });
    }

    mCPF(target){
        var cpf = target.value;
        cpf=cpf.replace(/\D/g,"")
        cpf=cpf.replace(/(\d{3})(\d)/,"$1.$2")
        cpf=cpf.replace(/(\d{3})(\d)/,"$1.$2")
        cpf=cpf.replace(/(\d{3})(\d{1,2})$/,"$1-$2")
        target.value = cpf;
    }
    
    mCNPJ(target){
        var cnpj = target.value;
        cnpj=cnpj.replace(/\D/g,"")
        cnpj=cnpj.replace(/^(\d{2})(\d)/,"$1.$2")
        cnpj=cnpj.replace(/^(\d{2})\.(\d{3})(\d)/,"$1.$2.$3")
        cnpj=cnpj.replace(/\.(\d{3})(\d)/,".$1/$2")
        cnpj=cnpj.replace(/(\d{4})(\d)/,"$1-$2")
        target.value = cnpj;
    }

    handleChange = (event, maskedvalue, floatvalue) => {
        this.setState({ amount: floatvalue });
    }
    
    handleSubmit = (e) => {
        e.preventDefault();

        this.setState({ erro: false });  

        this.props.form.validateFields((err, values) => {
            if (!err) {

                this.setState({ loading: true });
                //console.log(values);
//return;
                var filial = this.dadosProvider.getUiFilial();
                var usuario = this.dadosProvider.getDadosUsuario();

                var dados = {
                    "uiFilial": filial,
                    "cripto": usuario.Cripto,
                    "cdBanco": values.banco,
                    "nrAgencia": values.agencia,
                    "nrAgenciaDV": values.agencia_dv,
                    "nrConta": values.conta,
                    "nrContaDV": values.conta_digito,
                    "cdTipoContaBancaria": values.tipo_conta,
                    "stContaTerceiro": (values.terceiros) ? 1 : 0,
                    "dsNomeTitular": this.checkCampo(values.titular),
                    "cdTipoPessoaLei": this.checkCampo(values.tipo_pessoa),
                    "nrCPFCNPJ": (this.checkCampo(values.tipo_pessoa) != "") ? ( (values.tipo_pessoa == "1") ? this.checkCampo(values.cnpj) : this.checkCampo(values.cpf) ) : "",
                    "dsObs": this.checkCampo(values.observacao),
                    "cdPessoaContaBancaria": 0,
                    "vlChequeLimite": (typeof values.limite_cheque !== 'undefined') ? values.limite_cheque : "0",
                };

                this.dataService.SalvaContaBancaria(dados, (retorno) => {

                    this.setState({ loading: false });
        
                    if (retorno.Status === "1") {

                        Modal.success({
                            title: 'Sucesso',
                            content:(<div dangerouslySetInnerHTML={{ __html: this.htmlDecode(retorno.Msg) }} />)                    
                        });
        
                    } else {
                        Modal.error({
                            title: 'Erro',
                            content:(<div dangerouslySetInnerHTML={{ __html: this.htmlDecode(retorno.Msg) }} />)
                        });
                    }
        
                }, (erro) => {
                    console.log(erro);
                    this.setState({ loading: false });
                });
            }
        });
    }

    checkCampo(campo){
        return (typeof campo !== 'undefined' && campo != ".") ? campo : "";
    }

    htmlDecode(input) {
        var e = document.createElement('div');
        e.innerHTML = input;
        return e.childNodes.length === 0 ? "" : e.childNodes[0].nodeValue;
    }

    render() {

        const { getFieldDecorator } = this.props.form;

        return (
            
            <Form onSubmit={this.handleSubmit} className="formBanco">                                

                {this.state.buscando ?
                    (<Row>
                        <Col className="imageRadio">
                            <div className="divSpin">
                                <Spin className="imageSpin" />
                            </div>
                        </Col>
                    </Row>) 
                    : 
                
                (<div>
                   
                    {this.state.obConta["DsStatus"] != "." && this.state.obConta["DsStatus"] != undefined &&
                    this.state.obConta["DsStatus"] != "undefined" &&
                        <div> Situação do cadastro:
                            <Alert message={" " + this.state.obConta["DsStatus"]} 
                                type={this.state.tipoStatus} 
                                showIcon />
                        </div>
                    }

                    <FormItem
                        label="Banco">
                        {getFieldDecorator('banco', {                        
                            initialValue: this.state.obConta["CdBanco"],
                            rules: [{
                                required: false, message: 'Selecione o banco',
                            }],
                        })(
                            <Select
                                                            
                            >
                                {this.state.bancos.map(banco => <Option key={banco["CdBanco"]}>{banco["DsBanco"]}</Option>)}
                            </Select>
                        )}
                    </FormItem>

                    <Row gutter={8}>
                        <Col span={8}>
                            <FormItem
                                label="No.Agência">
                                {getFieldDecorator('agencia', {
                                    initialValue: this.state.obConta["NrAgencia"],
                                    rules: [{
                                        required: true, message: 'Insira o número da agência',
                                    }],
                                })(
                                    <Input />
                                )}
                            </FormItem>
                        </Col>
                        <Col span={4}>
                            <FormItem
                                label="DV">
                                {getFieldDecorator('agencia_dv', {
                                    initialValue: this.state.obConta["NrAgenciaDV"],
                                    rules: [{
                                        required: true, message: 'Insira o digito da agência',
                                    }],
                                })(
                                    <Input />
                                )}
                            </FormItem>
                        </Col>
                        <Col span={8}>
                            <FormItem
                                label="No.Conta">
                                {getFieldDecorator('conta', {
                                    initialValue: this.state.obConta["NrConta"],
                                    rules: [{
                                        required: true, message: 'Insira o número da conta',
                                    }],
                                })(
                                    <Input />
                                )}
                            </FormItem>
                        </Col>
                        <Col span={4}>
                            <FormItem
                                label="DV">
                                {getFieldDecorator('conta_digito', {
                                    initialValue: this.state.obConta["NrContaDV"],
                                    rules: [{
                                        required: true, message: 'Insira o digito da conta',
                                    }],
                                })(
                                    <Input />
                                )}
                            </FormItem>
                        </Col>
                    </Row>

                    <Row gutter={8}>
                        <Col span={14}>
                            <FormItem
                                label="Tipo Conta">
                                {getFieldDecorator('tipo_conta', {
                                    initialValue: this.state.obConta["CdTipoContaBancaria"],
                                    rules: [{
                                        required: false, message: 'Please input your E-mail!',
                                    }],
                                })(
                                    <Select>
                                        <Option value="1">Corrente</Option>
                                        <Option value="2">Poupança</Option>
                                        <Option value="3">Juridica</Option>                                    
                                    </Select>
                                )}
                            </FormItem>
                        </Col>
                        <Col span={10}>
                            <FormItem
                                label="Limite do Cheque">
                                {getFieldDecorator('limite_cheque', {
                                    initialValue: this.state.obConta["VlChequeLimite"],
                                    rules: [{
                                        required: false, message: 'Please input your E-mail!',
                                    }],
                                })(
                                    <CurrencyInput decimalSeparator="," thousandSeparator="." className="ant-input" value={this.state.amount} onChangeEvent={this.handleChange} />
                                )}
                            </FormItem>
                        </Col>
                    </Row>

                    <FormItem>
                        {getFieldDecorator('terceiros', {
                            valuePropName: (this.state.obConta["StContaTerceiro"] == "1") ? 'checked' : 'unchecked',
                            initialValue: (this.state.obConta["StContaTerceiro"] == "1"),
                            rules: [{
                                required: false, message: 'Please input your E-mail!',
                            }],
                        })(
                            <Checkbox
                                onChange={this.terceirosChange}>
                                Conta de Terceiros
                            </Checkbox>
                        )}
                    </FormItem>

                    <div className={(this.state.terceiros) ? "" : "displayNone"}>
                        <FormItem
                            label="Titular">
                            {getFieldDecorator('titular', {
                                initialValue: this.state.obConta["DsNomeTitular"],
                                rules: [{
                                    required: this.state.terceiros, message: 'Insira o nome do titular',
                                }],
                            })(
                                <Input />
                            )}
                        </FormItem>

                        <Row gutter={8}>
                            <Col span={10}>
                                <FormItem
                                    label="Tipo Pessoa">
                                    {getFieldDecorator('tipo_pessoa', {
                                        initialValue: this.state.obConta["StContaTerceiro"],
                                        rules: [{
                                            required: this.state.terceiros, message: 'Selecione o tipo de pessoa',
                                        }],
                                    })(
                                        <Select>
                                            <Option value="1">Jurídica</Option>
                                            <Option value="2">Física</Option>
                                        </Select>
                                    )}
                                </FormItem>
                            </Col>

                            <Col span={14}>
                                <FormItem
                                    className={(this.props.form.getFieldValue('tipo_pessoa') == "1") ? "" : "displayNone"}
                                    label="CNPJ">
                                    {getFieldDecorator('cnpj', {
                                        initialValue: this.state.obConta["NrCPFCNPJ"],
                                        rules: [{
                                            max: 18,
                                            required: this.state.terceiros && this.props.form.getFieldValue('tipo_pessoa') == "1", message: 'Insira o CNPJ corretamente',
                                        }],
                                    })(
                                        <Input type="tel" onChange={e => this.mCNPJ(e.target)} />
                                    )}
                                </FormItem>

                                <FormItem
                                    className={(this.props.form.getFieldValue('tipo_pessoa') == "2") ? "" : "displayNone"}                                
                                    label="CPF">
                                    {getFieldDecorator('cpf', {
                                        initialValue: this.state.obConta["NrCPFCNPJ"],
                                        rules: [{    
                                            max: 14,                                    
                                            required: this.state.terceiros && this.props.form.getFieldValue('tipo_pessoa') == "2", message: 'Insira o CPF corretamente',
                                        }],
                                    })(
                                        <Input type="tel" onChange={e => this.mCPF(e.target)} />
                                    )}
                                </FormItem>

                            </Col>
                        </Row>

                    </div>

                    <FormItem
                        label="Observação">
                        {getFieldDecorator('observacao', {
                            initialValue: this.state.obConta["DsObs"],
                            rules: [{
                                required: false, message: 'Please input your E-mail!',
                            }],
                        })(
                            <TextArea rows={2} />
                        )}
                    </FormItem>

                    <FormItem>
                        <Button
                            type="primary"
                            htmlType="submit"
                            className="login-form-button"
                            loading={this.state.loading}>
                            Salvar
                        </Button>
                    </FormItem>

                </div>)}
            </Form>  
        )
    }
}

export default Form.create()(DadosBancarios);


// WEBPACK FOOTER //
// ./src/Components/DadosBancarios/DadosBancarios.js